import React, { useEffect, useState } from 'react';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from '../../Analytics/Charts/CustomHighChart';
// import tempData from './tempdata/data_hist.json';

// const colors = _.shuffle(constants.colorObj);
const ChartEnergyConsumptionForecast = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const drawChart = async (_data) => {
    if (_data.length === 0) return;
    const { Battery_Storage_Kwh, NetDemand_Kw, PV_Generation_Kw, hour_of_day } =
      _data;

    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'chrtContainer',
        height: '500px',
        type: 'column',
      },
      xAxis: {
        type: 'category',
        categories: Object.values(hour_of_day),
        title: {
          text: 'Half Hours',
        },
      },
      yAxis: [
        {
          title: {
            text: 'Energy Kwh',
          },
        },
      ],
      series: [
        {
          name: 'Grid_Kwh',
          color: constants.colorObjLC.grid,
          data: NetDemand_Kw.map((x) => x * 0.5),
          legendIndex: 1,
        },
        {
          name: 'Battery_Kwh',
          color: constants.colorObjLC.battery,
          data: Object.values(Battery_Storage_Kwh),
        },
        {
          name: 'Solar_Kwh',
          color: constants.colorObjLC.solar,
          data: PV_Generation_Kw.map((x) => x * 0.5),
        },
      ],
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
      },
    });
    setLoading(false);
    setData(chart);
  };

  useEffect(() => {
    drawChart(props.data);
  }, [props.data]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default ChartEnergyConsumptionForecast;
